import { Button, Grid, TextField, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { ContactSettingsValidationSchema } from "../../Utils/Models";
import { yupResolver } from "@hookform/resolvers/yup";
import { useContext, useEffect } from "react";
import { getData } from "../../Services/getData";
import { AxiosResponse } from "axios";
import { endpoints } from "../../Utils/UrlEnum";
import { updateData } from "../../Services/updateData";
import { Vocabulary } from "../../Utils/Vocabulary";
import { Save } from "@mui/icons-material";
import styles from "../../Styles/settings.module.css";
import Config from "../../Utils/Config";
import { WebSocketContext } from "../../Context/WebSocketContext";
import { GreenSwitch } from "../../Utils/Utils";

export default function ContactSettings() {
  const websocketContext = useContext(WebSocketContext);
  const { control, handleSubmit, reset, watch } = useForm({
    resolver: yupResolver(ContactSettingsValidationSchema),
    mode: "onChange",
    reValidateMode: "onChange",
    context: undefined,
    shouldFocusError: true,
    shouldUnregister: false,
    criteriaMode: "firstError",
  });

  /**
   *
   */
  useEffect(() => {
    getData(endpoints.setting.contact).then((res: AxiosResponse) => {
      if (res?.data) {
        reset(res.data);
      }
    });
  }, []);

  /**
   *
   * @param data
   */
  const onSubmit = (data: any) => {
    const newMethod = Object.assign({}, data);
    const url = `${endpoints.setting.main}${newMethod?._id}`;
    updateData(url, newMethod).then((res: AxiosResponse) => {
      if (res?.data) {
        websocketContext.setShouldUpdate(!websocketContext.shouldUpdate);
        reset(res.data);
      }
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.settingsForm}>
      <Grid container spacing={Config.standardGridSpacing}>
        <Grid item xs={12} sm={12} md={12} lg={2.2}>
          <Typography>
            {Vocabulary.shouldRenderOldContactsOnDashboard}
          </Typography>
          <Controller
            name={`value.shouldRenderOldContacts`}
            control={control}
            render={({ field: { value, onChange, ref } }) => (
              <GreenSwitch onChange={onChange} checked={value} inputRef={ref} />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={8.7}>
          {watch("value.shouldRenderOldContacts") === true ? (
            <Controller
              name="value.contactDeletionThreshold"
              control={control}
              render={({ field: { onChange, value, ref } }) => (
                <TextField
                  id="contactDeletionThreshold"
                  name="contactDeletionThreshold"
                  label={Vocabulary.contactDeletionThreshold}
                  type="number"
                  fullWidth
                  variant="outlined"
                  onChange={onChange}
                  value={value || ""}
                  ref={ref}
                />
              )}
            />
          ) : null}{" "}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={10}
          xl={1}
          className={styles.oblioSettingsButtonContainer}
        >
          <Button
            type="submit"
            fullWidth
            startIcon={<Save />}
            variant="contained"
          >
            {Vocabulary.save}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
